export default "__VITE_ASSET__94f9424a__"